export default __webpack_public_path__ + "static/media/uploader-abbottNeo-problem-1.9cadc5c4.png";